export default "__VITE_ASSET__CTuOEXfl__"